<template>
  <div class="container">
    <!-- <div class="block">
      <div class="title-wrap">
        <div class="title-name">经营概况</div>
      </div>
      <div class="content-inner-wrap" v-loading="infoLoading">
        <div class="dataPanel">
          <div class="dataItem">
            <div class="dataItemInner">
              <p class="title">工作室成员</p>
              <p class="data">
                {{ member_count }}/{{ member_max }} <label>人</label>
              </p>
            </div>
          </div>
          <div class="dataItem">
            <div class="dataItemInner">
              <p class="title">加入/退出申请</p>
              <p class="data">{{ join_quit_count }} <label>条</label></p>
            </div> -->
    <!--申请审核-->
    <!-- <a
              class="handleImmediate"
              @click="
                $router.push({
                  name: 'StudioManagerApply',
                  params: { join_quit_count: join_quit_count }
                })
              "
              href="javascript:void(0);"
              >立即处理 <i class="el-icon-arrow-right"></i
            ></a> -->
    <!-- </div>
        </div>
      </div>
    </div> -->
    <div class="block">
      <div class="title-wrap">
        <!-- <div class="title-list">成员列表</div>
        <div class="title-invite">成员审核</div>
        <div class="title-permiss">权限设置</div> -->
        <div class="tab-list">
          <div
            @click="changeLabel(1)"
            :class="[activeName == 1 ? 'list active' : 'list']"
          >
            <div class="list-content">成员列表</div>
          </div>
          <div
            @click="changeLabel(2)"
            :class="[activeName == 2 ? 'invite active' : 'invite']"
          >
            <div class="invite-content" v-if="join_quit_count">
              <el-badge
                :value="join_quit_count"
                :max="999"
                class="item"
                type="warning"
              >
                <!-- <el-button size="small">成员审核</el-button> -->
                成员审核
              </el-badge>
            </div>
            <div class="invite-content1" v-else>
              <!-- <el-button size="small">成员审核</el-button> -->
              成员审核
            </div>
          </div>
          <div
            @click="changeLabel(3)"
            :class="[activeName == 3 ? 'permiss active' : 'permiss']"
          >
            <div class="permiss-content">成员权限</div>
          </div>
        </div>
        <!-- <el-tabs v-model="activeName" @tab-click="handelActiveCilck">
          <el-tab-pane label="成员列表" name="list">成员列表 </el-tab-pane>
          <el-tab-pane label="成员审核" name="invite">
            成员审核
            <el-badge :value="unread" :max="999" class="message" type="primary">
            </el-badge>
          </el-tab-pane>

          <el-tab-pane label="权限设置" name="permiss">权限设置 </el-tab-pane>
        </el-tabs> -->
      </div>
      <!--邀请入口-->
      <!--添加邀请-->
      <div
        class="title-invitate"
        @click="amendInvitation"
        v-if="activeName == 1"
      >
        <i class="el-icon-plus"></i>邀请成员
      </div>
      <!--   <div class="content-invitation" v-if="popupInvitation">
          
      </div>  -->
      <!--成员列表-->
      <div
        class="content-inner-wrap"
        v-loading="memberListLoading"
        v-if="activeName == 1"
      >
        <div class="title-wrap">
          <div class="title">
            <span class="desc">工作室成员</span>
            <span class="count">
              {{ member_count }}/{{ member_max }} <label>人</label></span
            >
          </div>
        </div>
        <div class="myTable-wrap">
          <el-table :data="membersData" stripe>
            <el-table-column
              align="center"
              prop="name"
              label="名字"
              class-name="tb-name"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="uin"
              label="迷你号"
              class-name="tb-uin"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="position"
              label="类型"
              class-name="tb-type"
            >
              <template slot-scope="scope">
                <span>{{ scope.row | positionName }}</span>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="join_time"
              label="加入时间"
              class-name="tb-joinTime"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.join_time | formatTime }}</span>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="options"
              label="操作"
              class-name="tb-options"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.position == '1'">室长</span>
                <span v-else-if="scope.row.position == '3'">
                  <!-- <el-button type="text" @click="setMember(scope.row.uin)">设置权限</el-button> | <el-button type="text" @click="delMember(scope.row.uin)">删除成员</el-button> -->
                  <el-button type="text" @click="handleDelClicked(scope.row)">
                    删除成员</el-button
                  >
                </span>
                <span v-else>
                  <template v-if="isVip">
                    <!-- eslint-disable-next-line prettier/prettier -->
                    <el-button type="text" @click="handleModifyClick(scope.row)">修改
                    </el-button>
                    |
                  </template>
                  <el-button type="text" @click="handleDelClicked(scope.row)">
                    删除成员
                  </el-button>
                </span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="data-filter-page">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="total_count"
            @current-change="paginationChange"
          >
          </el-pagination>
        </div>
      </div>
      <!--成员审核-->
      <Audit v-if="activeName == 2" @update="update"> </Audit>
      <permiss v-if="activeName == 3"> </permiss>
    </div>
    <el-dialog
      title="删除成员"
      :visible.sync="dialogDelMemberVisible"
      width="25%"
    >
      <p>成员：{{ willDelMember.name }}（{{ willDelMember.uin }}）</p>
      <p>
        加入时长：{{ willDelMember.joined_time }}天（{{
          willDelMember.timeStr
        }}加入）
      </p>
      <!-- <p>数据情况</p> -->
      <!-- <el-table :data="willDelMember.tableData">
        <el-table-column property="products" label="作品数"></el-table-column>
        <el-table-column property="adFlow" label="广告流水"></el-table-column>
        <el-table-column property="contribution" label="贡献点"></el-table-column>
      </el-table> -->
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmDeleteMemeber">
          确认删除</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      title="成员信息"
      :visible.sync="dialogModifyMemberVisible"
      width="25%"
    >
      <div class="memberInfo">
        <img
          :src="`http://map1.mini1.cn/roleicon/${willModifyMember.head_id}.png`"
        />
        <div class="memberInfoDeta">
          <p>{{ willModifyMember.name }}（{{ willModifyMember.uin }}）</p>
          <p>已加入：{{ willModifyMember.joined_time }}天</p>
        </div>
      </div>
      <el-form :model="willModifyForm" ref="changeMemberForm">
        <el-form-item label="成员类型">
          <el-radio-group v-model="willModifyMember.vip">
            <el-radio :label="0">普通成员</el-radio>
            <el-radio :label="1">签约成员</el-radio>
          </el-radio-group>
          <el-alert title="签约成员的所有收益将归属于工作室" type="warning">
          </el-alert>
        </el-form-item>
        <!-- <el-form-item label="职位设置">
          <el-radio-group v-model="willModifyMember.position">
            <el-radio :label="2">成员</el-radio>
            <el-radio :label="3">管理员</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item label="签约合同">
          <my-el-upload
            class="upload-demo"
            :action="upload_url"
            :on-remove="handleRemove"
            :on-change="onChange"
            :on-success="uploadSuccess"
            :file-list="fileList"
            :before-upload="onBeforeUpload"
            :name="upload_name"
            accept="image/png, image/jpeg, image/bmp, application/pdf"
            list-type="picture"
            ><el-button size="small" class="uploadBtn">
              <i class="icon icon-upload"></i><span>上传文件</span></el-button
            ></my-el-upload
          >
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmModifyMember">确 定</el-button>
        <el-button @click="cancelModifyMember">取 消</el-button>
      </div>
    </el-dialog>
    <!--邀请成员-->
    <el-dialog
      title="工作室成员邀请"
      :modal-append-to-body="false"
      :visible.sync="popupInvitation"
      width="600px"
      class="content-invitation"
      @close="closeDialog"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <div class="studioMemberInvitate">
        <div class="miniInvitate">
          <span class="mini-number">邀请迷你号</span>
          <el-input
            class="mini-number-input"
            placeholder="作者迷你号"
            v-model="judeNumber"
          >
          </el-input>
        </div>
        <!--弹出提示语-->
        <div class="mini-number-error" v-if="errorInput == 1">
          请输入正确的迷你号
        </div>
        <div class="mini-number-error" v-else-if="errorInput == 2">
          {{ confirmMessage }}
        </div>
        <div class="mini-number-error" v-else>
          <br />
        </div>
        <div class="invitation-letter">
          <div class="invitation-letter-container">
            <span class="letter-head">邀请信</span>
            <div class="invitation-letter-content">
              <div class="letter-content">{{ judeLetter }}</div>
            </div>
          </div>
          <div class="invitation-letter-submit">
            <el-button
              type="primary"
              @click="confirmInvite(judeNumber, judeLetter)"
              class="letter-submit"
              >确认邀请</el-button
            >
            <div class="letter-intro" style="text-align: center">
              邀请将以邮件方式发送，玩家同意后即可加入工作室。
              <br />
              目前工作室系统正在按照渠道逐步开放，若在游戏内无法看到工作室入口，请耐心等待入口开放，预计将在9月前完成全面开放
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import MyUpload from '../../../../components/MyUpload';
import Audit from './apply.vue';
import permiss from './permiss.vue';
import {
  getStudioStatus,
  getStudioMembers,
  delStudioMember,
  setStudioMember,
  addStudioMemberInvite,
} from '@/api/studio';
import {
  STUDIO_POSITION,
  ONE_DAY,
  UPLOAD_FILE_URL,
  UPLOAD_URL,
  isValidFileSize,
  DESCRIPTION_DEFAULT,
} from '../../CONST';
import pdfIcon from '../../../../assets/images/pdf.jpeg';
export default {
  components: {
    [MyUpload.name]: MyUpload,
    Audit,
    permiss,
  },
  data() {
    return {
      upload_url: UPLOAD_FILE_URL,
      upload_name: 'image',
      judeNumber: '',
      judeLetter: DESCRIPTION_DEFAULT,
      //judeLetter:"加油加油",
      activeName: 1,
      confirmMessage: '',
      errorInput: 0,
      unread: 1000,
      memberListLoading: false,
      infoLoading: false,
      join_quit_count: 0,
      member_count: 0,
      member_max: 5,
      total_count: 0,
      isVip: 0,
      pcount: 0,
      popupInvitation: false,
      miniNumberError: false,
      dialogModifyMemberVisible: false,
      dialogDelMemberVisible: false,
      willModifyMember: {
        uin: 0,
        name: '',
        join_time: '',
        joined_time: '',
        head_id: 0,
        position: 0,
        vip: 0,
      },
      willDelMember: {
        uin: 0,
        name: '',
        join_time: '',
        joined_time: '',
        tableData: [
          {
            products: 0,
            adFlow: 0,
            contribution: 0,
          },
        ],
        tips: '删除成员后，24小时内不可再次发起邀约',
      },
      willModifyForm: {
        memberType: 0,
        position: 0,
      },
      fileList: [],
      memberListPagination: {
        page: 1,
        page_size: 10,
      },
      membersData: [],
    };
  },
  created() {
    this.infoLoading = true;
    let studioBaseInfo = sessionStorage.getItem('studioBaseInfo');
    // this.judeLetter=studioBaseInfo.
    if (studioBaseInfo) studioBaseInfo = JSON.parse(studioBaseInfo);
    this.isVip = parseInt(studioBaseInfo.vip, 10);
    this.judeLetter = studioBaseInfo.description || DESCRIPTION_DEFAULT;
    getStudioStatus({ json: 1 }).then(res => {
      this.infoLoading = false;
      let { member_count, join_quit_count, member_max } = res.data;
      this.join_quit_count = join_quit_count;
      this.member_count = member_count;
      this.member_max = member_max;
      this.total_count = member_count; // Math.ceil(member_count / this.memberListPagination.page_size)
    });
    this.getMemberList();
    //工作室管理页曝光
    this.$log('studio_manage_show', 85444, { v7: 1 });
  },
  filters: {
    formatTime(time) {
      let t = new Date(time * 1000);
      return (
        t.getFullYear() +
        '-' +
        (101 + t.getMonth() + '').slice(-2) +
        '-' +
        (100 + t.getDate() + '').slice(-2)
      );
    },
    positionName(row) {
      if (row.position === 2 && row.vip) {
        return '签约成员';
      } else {
        return STUDIO_POSITION[row.position].value;
      }
    },
  },
  methods: {
    uploadSuccess(response, file, fileList) {
      console.log('uploadSuccess---', response, file, fileList);
      if (/\.pdf$/i.test(file.name)) {
        this.$nextTick(() => {
          document.querySelector('.el-upload-list__item-thumbnail').src =
            pdfIcon;
        });
      }
    },
    handelActiveCilck(tab, event) {
      console.log(tab, event);
    },
    onBeforeUpload(file) {
      if (file.type === 'application/pdf') {
        this.upload_url = UPLOAD_FILE_URL;
        this.upload_name = 'file_column';
      } else {
        this.upload_url = UPLOAD_URL;
        this.upload_name = 'image';
      }
      return new Promise(reslove => {
        this.$nextTick(() => {
          reslove(
            isValidFileSize(file.size, () =>
              this.$message.error('请限制文件大小在10M以内'),
            ),
          );
        });
      });
      //return isValidFileSize(file.size, () => this.$message.error('请限制文件大小在10M以内'))
    },
    handleRemove(file) {
      if (this.fileList[0].uid === file.uid) {
        this.fileList = [];
      }
    },
    update() {
      getStudioStatus({ json: 1 }).then(res => {
        this.infoLoading = false;
        let { member_count, join_quit_count, member_max } = res.data;
        this.join_quit_count = join_quit_count;
        this.member_count = member_count;
        this.member_max = member_max;
        this.total_count = member_count; // Math.ceil(member_count / this.memberListPagination.page_size)
      });
    },
    onChange(file) {
      let { status, response, name, uid } = file;
      if (status === 'success' && response.code === 200) {
        this.fileList = [
          { name, url: response.data[this.upload_name].cdn_url, uid },
        ];
      }
    },
    paginationChange(currPage) {
      this.memberListPagination.page = currPage;
      this.getMemberList();
    },
    getMemberList() {
      this.memberListLoading = true;
      getStudioMembers(
        Object.assign(this.memberListPagination, { json: 1 }),
      ).then(res => {
        this.memberListLoading = false;
        this.membersData = res.data || [];
      });
    },
    delMember(member_uin, cb) {
      delStudioMember({ member_uin, json: 1 }).then(res => {
        if (res.code == 0) {
          this.$message.success('移除成功');
          setTimeout(() => {
            this.memberListPagination.page = 1;
            this.getMemberList();
            cb && cb();
          }, 2000);
        }
      });
    },
    setMember(member_uin, position, vip, vip_contract, cb) {
      setStudioMember({
        member_uin,
        position,
        vip,
        vip_contract,
        json: 1,
      }).then(res => {
        if (res.code == 0) {
          this.$message.success(
            '成功发起签约，成员需在游戏邮件内同意后即可正式签约',
          );
        }
        cb && cb();
      });
    },
    formatTime(time) {
      let timeStr = new Date(time * 1000);
      return (
        timeStr.getFullYear() +
        '年' +
        (1 + timeStr.getMonth()) +
        '月' +
        timeStr.getDate() +
        '日'
      );
    },
    changeLabel(type) {
      this.activeName = type;
      console.log(this.activeName);
    },
    handleDelClicked(memberData) {
      let { join_time, name, uin, position, vip } = memberData;
      let joined_time = Math.round((Date.now() - join_time * 1000) / ONE_DAY);
      let timeStr = this.formatTime(join_time);
      this.willDelMember = {
        name,
        uin,
        position,
        vip,
        joined_time,
        timeStr,
        tableData: [],
      };
      this.dialogDelMemberVisible = true;
    },
    confirmDeleteMemeber() {
      this.delMember(this.willDelMember.uin, () => {
        this.dialogDelMemberVisible = false;
        this.willDelMember = {};
        this.getMemberList();
      });
    },
    confirmModifyMember() {
      let { uin, position, vip } = this.willModifyMember;
      if (vip == 1) {
        if (!this.fileList.length || !this.fileList[0].url) {
          return this.$message.error('签约成员请上传签约合同');
        }
      }
      this.setMember(
        uin,
        position,
        vip,
        this.fileList[0] ? this.fileList[0].url : '',
        () => {
          this.dialogModifyMemberVisible = false;
          this.willModifyMember = {};
          this.getMemberList();
          this.$refs['changeMemberForm'].resetFields();
          this.fileList = [];
        },
      );
    },
    cancelModifyMember() {
      this.dialogModifyMemberVisible = false;
      this.$refs['changeMemberForm'].resetFields();
      this.fileList = [];
    },
    handleModifyClick(data) {
      let { join_time, name, uin, position, vip, head_id } = data;
      let joined_time = Math.round((Date.now() - join_time * 1000) / ONE_DAY);
      let timeStr = this.formatTime(join_time);
      this.willModifyMember = {
        uin,
        name,
        joined_time,
        timeStr,
        position,
        vip,
        head_id,
      };
      this.dialogModifyMemberVisible = true;
    },
    amendInvitation() {
      this.popupInvitation = true;
      //邀请成员点击埋点
      this.$log('invite_member_click', 85445, { v7: 1 });
    },
    /*判断迷你玩账号是否存在问题，以及工作室是否存在异常*/
    confirmInvite(judeNumber, judeLetter) {
      let reg = /^[0-9]*$/;
      if (judeNumber) {
        if (reg.test(judeNumber) && parseInt(judeNumber) > 10000) {
          //账号格式正确,将邮件信息发送给后台
          this.toAddStudioMemberInvite(judeNumber, judeLetter);
        } else {
          this.errorInput = 1;
        }
      } else {
        this.errorInput = 1;
      }
    },
    closeDialog() {
      this.judeNumber = '';
      this.errorInput = 0;
    },
    /* 发送邀请请求 */
    toAddStudioMemberInvite(member_uin, letter) {
      addStudioMemberInvite({ member_uin, letter, json: 1 }).then(res => {
        /* 邀请成功 */
        if (res.code == 0) {
          this.$message.success('邀请成功');
        } else {
          // 邀请失败
          this.confirmMessage = res.msg;
          this.errorInput = 2;
        }
      });
    },
  },
};
</script>
<style
  src="../../../../assets/styles/introduce-common.scss"
  lang="scss"
  scoped
></style>

<style lang="scss" scoped>
$--color-primary: #fd9b21;
.container {
  .block {
    .title-wrap {
      padding-bottom: 0;
      margin-bottom: 18px;
      border-bottom: none;
      .tab-list {
        margin-top: 13px;
        display: flex;
        color: #595959;
        font-size: 18px;
        //margin-left: 32px;
        border-bottom: 1px solid #d9d9d9;
        .list {
          font-size: 20px;
          //font-family: MicrosoftYaHei;
          padding-bottom: 10px;
          margin-right: 19px;
          //margin-left: 19px;
          cursor: pointer;
          .list-content {
            //margin-left: 19px;
            line-height: 26px;
            //-webkit-background-clip: text;
            //-webkit-text-fill-color: transparent;
          }
        }
        .list.active {
          border-bottom: 4px solid #fd9b21;
          position: relative;
          color: #fd9b21;
          &:before {
            display: block;
            content: '';
            width: 0;
            border-width: 4px;
            border-style: solid;
            border-color: transparent transparent $--color-primary transparent;
            position: absolute;
            left: 50%;
            margin-left: -2px;
            bottom: 0;
          }
        }
        .invite {
          font-size: 20px;
          //font-family: MicrosoftYaHei;
          padding-bottom: 10px;
          margin-right: 19px;
          cursor: pointer;
          .invite-content1 {
            margin-top: -2px;
          }
        }
        .invite.active {
          border-bottom: 4px solid #fd9b21;
          position: relative;
          color: #fd9b21;
          &:before {
            display: block;
            content: '';
            width: 0;
            border-width: 4px;
            border-style: solid;
            border-color: transparent transparent $--color-primary transparent;
            position: absolute;
            left: 50%;
            margin-left: -2px;
            bottom: 0;
          }
        }
        .permiss {
          padding-bottom: 10px;
          font-size: 20px;
          cursor: pointer;
          line-height: 26px;
          background-clip: text;
          -webkit-background-clip: text;
        }
        .permiss.active {
          border-bottom: 4px solid #fd9b21;
          position: relative;
          color: #fd9b21;
          &:before {
            display: block;
            content: '';
            width: 0;
            border-width: 4px;
            border-style: solid;
            border-color: transparent transparent $--color-primary transparent;
            position: absolute;
            left: 50%;
            margin-left: -2px;
            bottom: 0;
          }
        }
      }
      //display: flex;
      // .title-list {
      //   border-right: 2px solid #ccc;
      //   padding-right: 8px;
      // }
      // .message {
      //   margin-top: 10px;
      // }
    }
    .title-invitate {
      float: right;
      //margin-top: -30px !important;
      //margin-right: 10px;
      display: block;
    }
    .content-inner-wrap {
      .title-wrap {
        font-size: 24px;
        .title {
          .desc {
            margin-right: 18px;
          }
          .count {
            color: #fd9b21;
            label {
              font-size: 14px;
              line-height: 19px;
              color: #8c8c8c;
            }
          }
        }
      }
    }
  }
  .dataPanel {
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    .dataItem {
      position: relative;
      width: 494px;
      padding: 30px 0;
      &::after {
        display: block;
        content: '';
        width: 2px;
        height: 84px;
        background: #d9d9d9;
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        margin: auto;
      }
      &:last-child::after {
        display: none;
      }
      .handleImmediate {
        position: absolute;
        right: 95px;
        bottom: 33px;
        font-size: 14px;
        line-height: 20px;
        color: #2b6ddf;
        text-decoration: none;
      }
      .dataItemInner {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        p {
          text-align: center;
        }
        .title {
          font-size: 16px;
          line-height: 21px;
          color: #262626;
          margin-bottom: 12px;
        }
        .data {
          font-size: 24px;
          line-height: 31px;
          color: #fd9b21;
          label {
            font-size: 14px;
            line-height: 19px;
            color: #8c8c8c;
          }
        }
      }
    }
  }
  .memberInfo {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    img {
      width: 80px;
      height: 80px;
      border-radius: 40px;
      margin-right: 10px;
    }
    .memberInfoDeta {
      display: flex;
      justify-content: center;
      align-items: flex-start;
      flex-direction: column;
      p {
        font-size: 16px;
        line-height: 2;
      }
    }
  }
  .content-invitation {
    border-radius: 8px;
    font-size: 24px;
    font-weight: 600;
    display: block;
    overflow-wrap: break-word;
    color: #262626;
    line-height: 34px;
    .studioMemberInvitate {
      .miniInvitate {
        display: flex;
        align-items: center;
        .mini-number {
          font-size: 16px;
          width: 83px;
          text-align: left;
          margin-right: 32px;
          line-height: 28px;
          color: #595959;
        }
        .mini-number-input {
          width: 360px;
          height: 40px;
          border-radius: 8px;
          // border: 1px solid #595959;
          // border: 1px solid #D9D9D9;
          .el-input el-input >>> .el-input__inner::placeholder {
            color: red;
          }
          /* 谷歌 */
          .el-input el-input >>> .el-input__inner::-webkit-input-placeholder {
            color: red;
          }
          /* 火狐 */
          .el-input >>> .el-input__inner:-moz-placeholder {
            color: red;
          }
          /*ie*/
          .el-input >>> .el-input__inner:-ms-input-placeholder {
            color: red;
          }
        }
      }
      .mini-number-error {
        margin: 16px auto 20px 119px;
        overflow-wrap: break-word;
        color: #ff5533;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        line-height: 22px;
        font-weight: 600;
      }
    }
    .invitation-letter {
      .invitation-letter-container {
        display: flex;
        //align-items: center;
        .letter-head {
          font-size: 16px;
          width: 83px;
          text-align: left;
          margin-right: 32px;
          line-height: 28px;
          color: #595959;
        }
        .invitation-letter-content {
          width: 360px;
          height: 200px;
          border-radius: 8px;
          border: 1px solid #d9d9d9;
          font-weight: 400;
          .letter-content {
            font-size: 16px;
            font-weight: 400;
            color: #bfbfbf;
            line-height: 22px;
            margin: 17px 25px auto 25px;
          }
        }
      }
      .invitation-letter-submit {
        margin-top: 42px;
        text-align: center;
        border-radius: 8px;
        .letter-submit {
          width: 200px;
          height: 50px;
          background: #fd9b21;
          border-radius: 4px;
          font-size: 20px;
        }
        .letter-intro {
          margin: 36px auto 24px;
          font-size: 16px;
          font-weight: 400;
          color: #c2c2c2;
          line-height: 22px;
          // height:384px;
        }
      }
    }
  }
  .uploadBtn {
    padding: 4px 16px;
    ::v-deep > span {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      .icon-upload {
        display: block;
        width: 28px;
        height: 28px;
        background: url('../../../../assets/images/icon-upload.svg') 0 0
          no-repeat;
        background-size: 28px;
        margin-right: 11px;
      }
      span {
        font-size: 16px;
        line-height: 21px;
        color: #595959;
      }
    }
  }
}
</style>
